// extracted by mini-css-extract-plugin
module.exports = {"partitionBox":"_2Dnxk","partitionHeader":"_24w-r","partitionContent":"_2spVS","partitionTitle":"zMeIb","settingItemContainer":"_3Dwue"};